import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NfrpAlertMessage, NfrpDefaultGridComponent, NfrpGridService, NfrpGridPaginatorComponent } from 'nfrp-shared-angular';
import { HttpErrorResponse } from '@angular/common/http';
import { alertMessages } from 'src/app/helpers/common-constants';
import { Observable, Subject } from 'rxjs';
import { FooterFeaturesService } from '../../services/footer-features.service';
import { ApiServiceEnum, FeatureTypeIDEnum } from 'src/app/helpers/enum';
import { PlanFundSearchResponse, PlanFundData, PaginateParameters, PlanAutocomplete } from '../../model/get-plan.model';
import { PlanDetailsService } from '../../services/plan-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { CustomModal } from '../../model/custom-modal.model';

@Component({
    selector: 'investment-advisor-activities',
    templateUrl: './investment-advisor-activities.component.html',
    styleUrl: './investment-advisor-activities.component.css',
    standalone: false
})
export class InvestmentAdvisorActivitiesComponent extends NfrpDefaultGridComponent<PlanFundSearchResponse> implements OnInit, OnDestroy {
  @Input() service: string;
  @ViewChild(NfrpGridPaginatorComponent)
  gridPaginator: NfrpGridPaginatorComponent;
  planFundResult$: Observable<PlanFundData[]> = this.planDetailsService.planFundResult$;
  numberOfItems: number;
  dataSource: PlanFundSearchResponse[];
  showRemovePlanModal = false;
  showRemoveAllPlansModal = false;
  showSendAllPlansModal = false;
  planToDelete: PlanFundData;
  userTypeId: number;
  private subscriptions = [];
  userEmail: string;
  title: string;
  planNo: string;
  selPlanNo: number;
  submitted = false;
  disableForProcessing = false;
  sendAllPlansSpinner = false;
  size = 5;
  pages = 0;
  errorMessage: NfrpAlertMessage;
  successMessage: NfrpAlertMessage;
  planSearchText: string;
  showPlanResults = false;
  private componentDestroyed$ = new Subject<void>();
  options: PlanAutocomplete[];
  addPlanModal = false;
  planToAdd = '';
  planToAddMessage = '';
  sendAllPlansMessage = '';
  removeAllPlansMessage = '';


  constructor(
    nfrpGridService: NfrpGridService<PlanFundSearchResponse>,
    private planDetailsService: PlanDetailsService,
    private footerFeaturesService: FooterFeaturesService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(nfrpGridService);
  }

  ngOnInit(): void {
    const loginUser = sessionStorage.getItem('loginUser');
    this.userTypeId = loginUser ? JSON.parse(loginUser)?.userTypeId : '';
    this.userEmail = loginUser ? JSON.parse(loginUser)?.userEmail : '';
    this.subscriptions.push(
      this.footerFeaturesService.getSubFooterDetails(FeatureTypeIDEnum.INVESTMENT_ADVISOR_ACTIVITIES, this.userEmail).subscribe()
    );
    //this.getBatchProcessStatus();
    this.title = this.getTitle();
    this.getPlanFunds();
  }

  getTitle(): string {
    return this.service === ApiServiceEnum.WILSHIRE_PLAN_ADV ? 'Wilshire Plan Adv Marking' : 'Wilshire Plan Marking';
  }

    //START new plan call
    getPlanFunds(): void {
        this.planDetailsService
          .getPlanFunds(this.service, this.pages, this.size)
          .subscribe(
            (response: any) => {
              //console.log(response);
              this.errorMessage = { message: '', details: [] };
              //if (this.userTypeID === UserTypeIDEnum.RIA) {
                //this.dataSource = response?.plans ? response.plans : [];
              //} else {
                //this.dataSource = response?.plans.filter((planResult) => planResult?.planArchived === 1);
              //}
              if(!!response) {
                this.dataSource = response.wilshirePlanFlaggingDtoList;
                this.numberOfItems = response.totalElements;
              } else {
                this.dataSource = [];
              }
              this.setupGrid();
              window.scroll(0, 0);
            },
            (error) => {
              this.dataSource = [];
              this.setupGrid();
              this.errorMessage = { message: error, details: [] };
            }
          );
      }
      // END new plan call

      /*sendAllPlans(): void {
          this.searchQuery = this.retailUserForm.get('searchQuery').value;
          if (this.searchQuery) {
            this.isRecordsList = true;
            if (!this.isInternal && (this.searchQuery === this.loginDetails.nwId || this.searchQuery === this.loginDetails.nwEmail)){
              this.resetTable();
              this.errorMessage = { message: alertMessages.USER_NOT_ALLOWED_TO_SEARCH_WITH_NW_CREDENTIALS, details : []}
            }
            else {        
              this.getUsersListDetails(this.searchQuery);
            }
            
          }
        }*/

          /*sendSelectedPlans() {
              this.submitted = true;
                const flagPlansReqObj = {
                  planNo: this.planNo,
                };
          
                this.subscriptions.push(
                  this.planDetailsService.sendSelectedPlansToWilshire(this.service, this.selPlanNo).subscribe(
                    (sendSelectedPlanResponse) => {
                      window.scroll(0, 0);
                      //this.successMessage = { message: sendSelectedPlanResponse.status, details: [] };
                      this.errorMessage = { message: '', details: [] };
                    },
                    (error: HttpErrorResponse) => {
                      window.scroll(0, 0);
                      this.successMessage = { message: '', details: [] };
                      this.errorMessage = { message: alertMessages.SYSTEM_UNAVAILABLE_MESSAGE, details: [] };
                    }
                  )
                );
              
            }*/

  getBatchProcessStatus(): void {
    this.planDetailsService
      .getWilshireBatchProcess(this.service)
      .subscribe(
        (response: any) => {
          if (response.batchProcessRunning === true) {
            this.disableUIWhileBatchProcessing();
          }
        },
        (error) => {
          this.errorMessage = { message: 'Could not retrieve batch process status', details: [] };
        }
    );
  };

  disableUIWhileBatchProcessing(): void{
    this.successMessage = { message: 'Batch Process is currently running, please check back later.', details: [] };  
    this.disableForProcessing = true;
  }
  
  sort(event: any): void {
    // Add sorting logic here
  }

  searchSubmit(): void {
    this.subscriptions.push(
      //this.searchUserService.getPlansBySearch(this.userId, this.searchQuery).subscribe((response: any) => {
        //this.dataSource = response;
       // this.numberOfItems = this.dataSource?.length;
       // this.setupGrid();
       // this.paginate({
       //   limit: 20,
       //   offset: 1,
       // })
      //},
      //(error) => {
        //this.errorMessage = { message: error, details: [] };
        //this.successMessage = { message: '', details: [] };
      //})
    );
  }

  togglePlanSendInd(event: any, planNo: string): void {
    const checkbox = event.target;
    const sendInd = checkbox.checked;
    const originalValue = !sendInd;

    this.subscriptions.push(
      this.planDetailsService.togglePlanSendInd(this.service, planNo, sendInd).subscribe(
        (response: any) => {
          this.errorMessage = { message: '', details: [] };
          this.successMessage = { message: response.status, details: [] };
          this.getPlanFunds();
        },
        (error: string) => {
          checkbox.checked = originalValue;
          this.changeDetectorRef.detectChanges();

          this.successMessage = { message: '', details: [] };
          this.errorMessage = {
            message: error || 'Operation failed',
            details: []
          };
        }
      )
    )
  }

  handleSendAllPlans(){
    this.showSendAllPlansModal = true;
    this.sendAllPlansMessage = `Are you sure you want to add all eligible plans for ${this.service}?`; 
  }

  handleSendAllPLansYes() {
    this.showSendAllPlansModal = false;
    this.pages = 0;
    this.sendAllEligiblePlans();
  }

  handleSendAllPLansNo() {
    this.showSendAllPlansModal = false;
  }

  sendAllEligiblePlans(): void {
    this.disableForProcessing = true;
    this.sendAllPlansSpinner = true;
    this.subscriptions.push(
      this.planDetailsService.addAllEligiblePlans(this.service).subscribe(
        (response: any) => {
          this.errorMessage = { message: '', details: [] };
          this.successMessage = { message: response.status || 'All Eligible Plans Sent', details: [] };
          this.resetGridPaginator();
          this.disableForProcessing = false;
          this.sendAllPlansSpinner = false;
        },
        (error: string) => {
          this.disableForProcessing = false;
          this.sendAllPlansSpinner = false;
          this.successMessage = { message: '', details: [] };
          this.errorMessage = {
            message: error || 'Plans could not be sent',
            details: []
          };
        }
      )
    )
  }

  handleDeletePlan(planResult: PlanFundData) {
    this.planToDelete = planResult;
    this.showRemovePlanModal = true;
  }

  handleDeletePlanNo(): void {
    this.planToDelete = undefined;
    this.showRemovePlanModal = false;
  }

  handleDeletePlanYes(): void {
    this.showRemovePlanModal = false;
    this.deletePlanFromFlagging(this.planToDelete);
  }

  deletePlanFromFlagging(planResult: PlanFundData) {
    const removePlanList = [];
    removePlanList.push(planResult);
    this.planDetailsService.wilshireDeletePlan(removePlanList).subscribe(
      (response: any) => {
        this.errorMessage = { message: '', details: [] };
        this.successMessage = { message: response.status || 'Plan deleted successfully', details: [] };
        this.pages = 0;
        this.resetGridPaginator();
      },
      (error: string) => {
        window.scroll(0, 0);
        this.successMessage = { message: '', details: [] };
        this.errorMessage = { message: error || 'Plan could not be deleted', details: [] };
      }
    )
  }

  resetGridPaginator(){
    const paginateEvent: PaginateParameters = {
      limit: this.size,
      offset: 0
    };
    this.getPlanFunds();
    window.scroll(0, 0);
    if (this.gridPaginator) {
      this.gridPaginator.currentPageNumber = 1;
      this.gridPaginator.goToFirstPage();
    }
    this.paginate(paginateEvent);
  }

  planFundRowClicked(planFundData: PlanFundData) {
    this.planNo = planFundData.planNo;
  }

  paginate(event: PaginateParameters): void {
    const prevPageNumber = this.pages;
    const prevItemsPerPage = this.size;
    this.size = event?.limit;
    //feigeb: reduce page number by 1 because backend pages start at page 0 not 1
    this.pages = Math.floor((event?.offset + event?.limit - 1) / event?.limit) - 1;
    this.pages = this.pages >= 0 ? this.pages : 0;
    if (prevItemsPerPage != this.size || prevPageNumber != this.pages) {
      this.getPlanFunds();
    }
  }

  filterSearch(input: string): void {
    this.clearMessages();
    if (input?.length > 3) {
      this.planDetailsService
        .getWilshireAutocompletePlans(input, this.service)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          (res) => {
            this.options = undefined;
            if (res && res.planList.length > 0) {
              this.options = res.planList;
            }
            this.showPlanResults = true;
          },
          (err) => {
            this.errorMessage = { message: err.error, details: [] };
          }
        );
    } else {
      this.clearSearchResutls();
    }
  }

  clearMessages(): void{
    this.errorMessage = { message: '', details: [] };
    this.successMessage = { message: '', details: [] };
  }

  onClickAway(){
    setTimeout(() => {
      this.showPlanResults = false;
    }, 500);
  }

  selectedPlan(option: any): void {
    this.clearMessages();
    this.planSearchText = option?.planNo;
    this.planToAddMessage = `Are you sure you want to add plan ${option?.planNo}?`
    this.addPlanModal = true;
  }

  addPlanForFlaggingNo(): void {
    this.addPlanModal = false;
  }

  addPlanForFlaggingYes(): void {
    const planFundData = this.createNewWilshirePlanFlaggingObject(this.planSearchText)
    this.planDetailsService
    .addPlanToWilshirePlanFlagging(planFundData)
    .pipe(takeUntil(this.componentDestroyed$))
    .subscribe(
      (res) => {
        this.successMessage = { message: res.status, details: [] };
        this.addPlanModal = false;
        this.planSearchText = '';
        this.clearSearchResutls();
        this.getPlanFunds();
      },
      (err) => {
        this.successMessage = { message: '', details: [] };
        this.errorMessage = {
          message: err || 'Plans could not be deleted',
          details: []
        };
        this.addPlanModal = false;
      }
    );
  }

  createNewWilshirePlanFlaggingObject(planNo: string): PlanFundData {
    const newPlan: PlanFundData = {
      planNo: planNo,
      service: this.service,
      flaggedToSendInd: 'Y',
      sentInd: 'N'
    };
    return newPlan;
  }

  clearSearchResutls(): void {
    this.planSearchText = undefined;
    this.showPlanResults = false;
  }

  handleRemoveAllPlans() {
    this.showRemoveAllPlansModal = true;
    this.removeAllPlansMessage = `Are you sure you want to remove all non-error plans for ${this.service}?`;
  }

  handleRemoveAllPlansNo(){
    this.showRemoveAllPlansModal = false;
  }

  handleRemoveAllPlansYes() {
    this.showRemoveAllPlansModal = false;
    this.pages = 0;
    this.removeAllNonErrorPlans();
  }

  removeAllNonErrorPlans() {
    this.disableForProcessing = true;
    this.sendAllPlansSpinner = true;
    this.subscriptions.push(
      this.planDetailsService.deleteAllNonErrorPlans(this.service).subscribe(
        (response: any) => {
          this.errorMessage = { message: '', details: [] };
          this.successMessage = { message: response.status || 'All non-error plans deleted', details: [] };
          this.resetGridPaginator();
          this.disableForProcessing = false;
          this.sendAllPlansSpinner = false;          
        },
        (error: string) => {
          this.disableForProcessing = false;
          this.sendAllPlansSpinner = false;
          this.successMessage = { message: '', details: [] };
          this.errorMessage = {
            message: error || 'Plans could not be deleted',
            details: []
          };
        }
      )
    )
  }

    ngOnDestroy(): void {
      for (const subscriptions$ of this.subscriptions) {
        subscriptions$.unsubscribe();
      }
    }

}
